import stylesheet_19 from '../stylesheets/19.js';
import stylesheet_18 from '../stylesheets/18.js';
import stylesheet_20 from '../stylesheets/20.js';

export const index = 9;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/services/accelerated-training/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/9.e3c9fe2f.js","_app/immutable/chunks/scheduler.5b890119.js","_app/immutable/chunks/index.1673eb25.js","_app/immutable/chunks/Wrapper.a05beb49.js","_app/immutable/chunks/Hero.89c50aee.js","_app/immutable/chunks/each.15f1f0ab.js","_app/immutable/chunks/ContentCard.e15d56dd.js"];
export const stylesheets = ["_app/immutable/assets/Wrapper.54de1bd5.css","_app/immutable/assets/Hero.71a30b75.css","_app/immutable/assets/ContentCard.b5a2f49f.css"];
export const fonts = [];
export const inline_styles = () => ({
	"_app/immutable/assets/Wrapper.54de1bd5.css": stylesheet_19,
	"_app/immutable/assets/Hero.71a30b75.css": stylesheet_18,
	"_app/immutable/assets/ContentCard.b5a2f49f.css": stylesheet_20
});
